// Carry this approved campaign through the website to Apple; no cookies or storage.
(() => {
  const campaign = 'linkedin-ios-20261022-web';
  const current = new URL(window.location.href);
  if (current.searchParams.get('ct') !== campaign) return;

  const parameters = new URLSearchParams({ ct: campaign });
  const allowedValues = {
    utm_source: /^linkedin$/,
    utm_medium: /^paid-social$/,
    utm_campaign: /^linkedin-ios-20261022-web$/,
    utm_content: /^[a-zA-Z0-9_-]{1,100}$/,
    utm_id: /^[0-9]{1,20}$/,
  };
  for (const [name, pattern] of Object.entries(allowedValues)) {
    const value = current.searchParams.get(name);
    if (value && pattern.test(value)) parameters.set(name, value);
  }

  const isContentPage = (pathname) =>
    /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(pathname) ||
    /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages|blogs)\/(?:[a-z0-9_-]+\/)*[a-z0-9_-]+\/?$/i.test(pathname);

  const decorateLink = (link) => {
    const href = link.getAttribute('href')?.trim();
    if (!href || href.startsWith('#') || link.hasAttribute('download')) return;
    let destination;
    try { destination = new URL(href, current); } catch { return; }
    if (destination.protocol !== 'https:' && destination.protocol !== 'http:') return;

    if (destination.protocol === 'https:' && destination.hostname === 'apps.apple.com' &&
        /^\/(?:[a-z]{2}\/)?app\/(?:[^/]+\/)?id6480512341\/?$/i.test(destination.pathname)) {
      destination.searchParams.set('pt', '126205226');
      destination.searchParams.set('ct', campaign);
      destination.searchParams.set('mt', '8');
    } else if (destination.origin === current.origin && isContentPage(destination.pathname)) {
      for (const [name, value] of parameters) destination.searchParams.set(name, value);
    } else {
      return;
    }
    link.href = destination.href;
  };

  const decorateLinks = (root = document) => {
    if (root.matches?.('a[href]')) decorateLink(root);
    root.querySelectorAll('a[href]').forEach(decorateLink);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => decorateLinks(), { once: true });
  } else {
    decorateLinks();
  }
  document.addEventListener('shopify:section:load', (event) => decorateLinks(event.target));
})();
